"use strict";
/* eslint-disable camelcase */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var fetchApi_1 = __importDefault(require("../../rest/fetchApi"));
var notificationsApi_1 = require("../mock/notificationsApi");
var notificationsServiceUrl = process.env.CB_NOTIFICATIONS_SERVICE_SERVER_URL;
var NotificationsAPIs = {
    getNotificationsByUuid: function (token, first, offset) {
        return fetchApi_1.default.get({
            mockFunc: function () { return ({ json: notificationsApi_1.mockNotifications }); },
            url: "".concat(notificationsServiceUrl, "/notifications?first=").concat(first, "&offset=").concat(offset),
            returnResponse: true,
            token: token,
        });
    },
    deleteNotification: function (body) {
        return fetchApi_1.default.put({
            mockFunc: function () { return ({ json: notificationsApi_1.mockDeleteNotification }); },
            url: "".concat(notificationsServiceUrl, "/notifications/dismiss/").concat(body.id),
            returnResponse: true,
            token: body.token,
            body: body,
        });
    },
    getHasNewNotifications: function (token) {
        return fetchApi_1.default.get({
            mockFunc: function () { return ({ json: notificationsApi_1.mockHasNewNotifications }); },
            url: "".concat(notificationsServiceUrl, "/notifications/has_new"),
            returnResponse: true,
            token: token,
        });
    },
};
exports.default = NotificationsAPIs;
